export const ROUTES = {
  AUTH: '/auth',
  HOME: '/',
  PROFILE: 'profile',
  LAND_AREA: 'land-area',
  COSMIC_MONITORING: 'cosmic-monitoring',
  HARVEST: 'harvest',
  HARVEST_STATISTICS: 'harvest/statistics',
  HARVEST_LOCATIONS: 'harvest/locations',
  HARVEST_CLUSTERS: 'harvest/clusters',
  HARVEST_CLUSTER_DETAILS: 'harvest/clusters/:taxNumber',
  HARVEST_LOCATION_DETAILS: 'harvest/locations/:placeId',

  BIRJA: 'birja',
  BANK: 'bank',
  AGROPORTAL: 'agroportal',
  AGROSUBSIDIYA: 'agrosubsidiya',
  INSURANCE: 'insurance',
  FUNDING_CONTROL: 'funding_control',
  MATERIAL_CONTROL: 'material_control',
  // Admin Users
  USERS: '/users',
  USERS_CREATE: '/users/create',
  USERS_EDIT: '/users/edit/:id',

  // Roles
  ROLES: '/roles',
  ROLES_CREATE: '/roles/create',
  ROLES_EDIT: '/roles/edit/:id',

  // Seeds
  SEEDS: 'seeds',
  NOT_FOUND: '*',
};

/** `ROUTES.HARVEST` ichidagi nisbiy yo'llar — router'da child route sifatida
 *  ishlatiladi. Yuqoridagi to'liq yo'llar esa havola/navigatsiya uchun. */
export const HARVEST_ROUTES = {
  STATISTICS: 'statistics',
  LOCATIONS: 'locations',
  LOCATION_DETAILS: 'locations/:placeId',
  CLUSTERS: 'clusters',
  CLUSTER_DETAILS: 'clusters/:taxNumber',
};
